import { SwitchProps, Switch } from '@mui/material';
import { styled } from '@mui/material/styles';

const backgroundSwitchCircleColor = '#fff';
const backgroundSwitchTrackColor = '#03b212';
const backgroundSwitchTrackInactiveColor = '#eeeeef';
const switchHeight = 27;

export const SwitchStyled = styled(Switch)<SwitchProps>(({ theme }) => ({
  '&.MuiSwitch-root': {
    width: 50,
    height: switchHeight,
    padding: 0,
    margin: theme.spacing(1),
    display: 'flex',
    overflow: 'visible',
  },

  '& .MuiSwitch-switchBase': {
    padding: 0,
    color: backgroundSwitchCircleColor,

    '&.Mui-checked': {
      color: backgroundSwitchCircleColor,
      transform: 'translate(25px, 0px)',
    },

    '&.Mui-checked + .MuiSwitch-track': {
      backgroundColor: backgroundSwitchTrackColor,
      opacity: '1',
    },

    '&.Mui-disabled': {
      color: backgroundSwitchCircleColor,
    },

    '&.Mui-disabled.Mui-checked': {
      color: backgroundSwitchCircleColor,
    },

    '&.Mui-disabled + .MuiSwitch-track': {
      backgroundColor: backgroundSwitchTrackInactiveColor,
      opacity: 0.45,
    },

    '&.Mui-checked.Mui-disabled + .MuiSwitch-track': {
      backgroundColor: backgroundSwitchTrackColor,
      opacity: 0.45,
    },
  },

  '& .MuiSwitch-thumb': {
    width: switchHeight,
    height: switchHeight,
    boxShadow: 'none',
    border: `1px solid ${theme.palette.border.primary}`,
  },

  '& .MuiSwitch-track': {
    backgroundColor: backgroundSwitchTrackInactiveColor,
    borderRadius: switchHeight / 2,
    opacity: '1',
  },
}));
